<template>
  <div>
    <Popup
      :zIndex="zIndex"
      :isShow="shows"
      class="popup-box"
      :class="{
        'is-tab': isFromTab,
      }"
      @clickMask="shows = false"
    >
      <div v-if="upgradeLongTerm" slot="content" class="popup-wrapper">
        <LoadingMask v-if="requestLoading"></LoadingMask>
        <div class="rules-wrapper">
          <!-- 标题 -->
          <h5 class="title">{{ upgradePlanTitle }}</h5>
          <!-- 套餐说明 -->
          <div class="plan_wrap">
            <div class="plan_box">
              <h5>{{ upgradePlanText }}</h5>
              <div class="price">
                {{
                  $t(
                    'FoodC_membership_mteQ_ejcJ',
                    { money: upgradeLongTerm.monthPriceSplit.display } /*bb/月*/,
                  )
                }}
              </div>
              <div class="favorable">
                <p>{{ upgradePlanMoney }}</p>
                <p v-html="$t('FoodC_membership_ootV_ZRYt', { percent: upgradeSavePercent })"></p>
              </div>
            </div>
          </div>
          <!-- 文案-->
          <SubscribeGuideV2
            v-if="isCanSubscribe"
            class="subscribe-guide-style"
            :membership="membership"
            :upgradeLongTerm="upgradeLongTerm"
            :isUpgrade="true"
          />
          <!-- 支付卡 -->
          <div class="change-payment">
            <ChangePaymentV2
              v-if="shows"
              :paymentMethod="paymentMethod"
              :hasCardInfo="hasCardInfo"
              :renewPrice="upgradeLongTerm.renewPrice"
              styleSource="integratedPay"
              @changePaymentFn="changePaymentFn"
            />
          </div>
        </div>
        <!-- 按钮 -->
        <div
          class="rule-btn"
          :class="{
            'footer-container-tab': isFromTab,
            'footer-android-big': isAndroid && !isFromTab,
          }"
        >
          <rich-button
            :disabled="!hasCardInfo || upgradeBtnLoading"
            :loading="upgradeBtnLoading"
            :class="{ 'btn-loading': upgradeBtnLoading }"
            @click="handleUpgrade"
          >
            <div v-if="!upgradeBtnLoading" class="price-box">
              {{ upgradePlanText }}&nbsp;{{ upgradeLongTerm.priceSplit.display }}
            </div>
          </rich-button>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Popup from '@/components/vant-popup-member/index.vue'
import ChangePaymentV2 from './v2/change-payment-v2.vue'
import SubscribeGuideV2 from './v2/subscribe-guide-v2.vue'
import LoadingMask from '@/components/loading/loading-mask.vue'
import {
  getRecommendPaymentMethod,
  getCheckBuyMember,
  memberBuyFree,
  getBenefitsCreateV2Fulfillment,
  getFintechParams,
} from '@/api/member/index.js'
import { isEmpty } from 'lodash-es'
import { getPaymentSDKVersion, doPayV2 } from '@/common/js/bridge.js'
import {
  DIDI_FOOD_BRAND,
  INTEGRATED_DIALOG_CLICK_TYPE,
  CYCLE_TYPE,
  SCENARIO_CODE,
  PAY_STATUS,
  SCENE_PAY,
  SALES_CHANNEL,
} from '../common/enumsUtil.js'
import { membershipUpgradePopupSw, membershipUpgradePopupCk } from '../trackEvent.js'
import mixin from '@/page/member/mixins.js'

export default {
  name: 'UpgradeLongTermPopup',
  components: {
    Popup,
    ChangePaymentV2,
    LoadingMask,
    SubscribeGuideV2,
  },
  mixins: [mixin],
  inject: ['initCodeData'],
  model: {
    prop: 'showTips',
    event: 'showsChange',
  },
  props: {
    showTips: {
      type: Boolean,
      default: false,
      required: false,
    },
    upgradeLongTerm: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      DIDI_FOOD_BRAND,
      paymentMethod: {},
      hasCardInfo: false,
      zIndex: '1001',
      upgradeBtnLoading: false,
      requestLoading: false,
      successDialogData: {},
    }
  },
  computed: {
    ...mapState(['paySuccessInfo', 'foodNotOpen']),
    isCanSubscribe() {
      return this.upgradeLongTerm?.canSubscribe
    },
    upgradePlanTitle() {
      let text = ''
      switch (this.upgradeLongTerm?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_tOCk_ZLUS')
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_bNzP_hekS')
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_MEEh_ctts')
          break
      }
      return text
    },
    upgradePlanText() {
      let text = ''
      switch (this.upgradeLongTerm?.cycleType) {
        case CYCLE_TYPE.quarter:
          text = this.$t('FoodC_membership_dmqk_wJgV')
          break
        case CYCLE_TYPE.halfYear:
          text = this.$t('FoodC_membership_XTeP_nLeJ')
          break
        case CYCLE_TYPE.year:
          text = this.$t('FoodC_membership_BIGZ_CvrZ')
          break
      }
      return text
    },
    upgradePlanMoney() {
      let money = ''
      const dynamicContent = {
        money: this.upgradeLongTerm?.priceSplit?.display,
      }
      switch (this.upgradeLongTerm?.cycleType) {
        case CYCLE_TYPE.quarter:
          money = this.$t('FoodC_membership_uAos_hrFr', dynamicContent)
          break
        case CYCLE_TYPE.halfYear:
          money = this.$t('FoodC_membership_CHIm_nRPw', dynamicContent)
          break
        case CYCLE_TYPE.year:
          money = this.$t('FoodC_membership_nksN_IHwY', dynamicContent)
          break
      }
      return money
    },
    upgradeSavePercent() {
      const savePercent = this.upgradeLongTerm?.savePercent
      return `<span>${savePercent}%</span>`
    },
    btnTextLength() {
      return this.btnText?.length || 0
    },
    shows: {
      get: function () {
        return this.showTips
      },
      set: function (value) {
        this.$emit('showsChange', value)
      },
    },
    getTrackParams() {
      return {
        card_suffix: this.paymentMethod?.channelName || '无卡',
        sell_price: this.upgradeLongTerm?.price,
      }
    },
  },
  watch: {
    async shows(newV, oldV) {
      if (newV) {
        await this.initData()
        membershipUpgradePopupSw({ ...this.getTrackParams })
      }
    },
  },
  methods: {
    openRule() {
      this.$emit('openRule')
    },
    async initData(params) {
      await getPaymentSDKVersion({}, async ({ version }) => {
        this.requestLoading = true
        const res = await getRecommendPaymentMethod({ cashierSDKVersion: version, ...params })
        if (res.errno === 0) {
          this.paymentMethod = res?.data?.paymentMethod || {}
          if (!isEmpty(this.paymentMethod)) {
            this.hasCardInfo = true
          }
        }
        this.requestLoading = false
      })
    },
    // 更改支付方式
    async changePaymentFn(val) {
      membershipUpgradePopupCk({
        ...this.getTrackParams,
        click_type: INTEGRATED_DIALOG_CLICK_TYPE.SELECT_PAYMENT_METHOD,
      })
      // 修改了支付方式
      if (val?.changed === 1) {
        // 更新当前视图
        const payMethod = val?.pay_method?.[0] || {}
        const paymentMethodInfo = {
          channelID: payMethod?.channel_id * 1,
          cardIndex: payMethod.extra_info?.card_index || 0,
        }
        // 获取更换支付卡信息
        this.initData(paymentMethodInfo)
      }
    },
    async handleUpgrade() {
      membershipUpgradePopupCk({
        ...this.getTrackParams,
        click_type: INTEGRATED_DIALOG_CLICK_TYPE.PAY_BTN,
      })
      const val = this.paymentMethod
      const productId = this.upgradeLongTerm?.saleID
      const price = this.upgradeLongTerm?.price
      const canSubscribe = this.upgradeLongTerm?.canSubscribe
      this.upgradeBtnLoading = true
      this.successDialogData = {
        // 升级成功弹窗, 提前设置数据
        date: this.upgradeLongTerm?.enableDate,
        price: this.upgradeLongTerm?.renewPriceSplit?.display,
        cycleType: this.upgradeLongTerm?.cycleType,
        iconUrl: this.paySuccessInfo?.iconUrl,
      }
      if (price * 1 === 0) {
        // 只有在0元购的时候获取是否重复购买
        const res = await getCheckBuyMember({
          scene: SCENE_PAY.updrage,
        })
        this.isCheckBuyMember = res?.data?.canPurchase
        // 判断是不是有锁定的会员，只有当canPurchase=false，才刷新页面
        if (this.isCheckBuyMember === false) {
          this.closeUpgradeDialogAndLoading()
          this.requestLoading = true
          await this.initCodeData()
          this.requestLoading = false
          return
        }
        const channelID = val?.channelID * 1
        const cardIndex = val?.cardIndex * 1 || 0
        await this.zeroPayment(channelID, cardIndex)
        this.closeUpgradeDialogAndLoading()
        return
      }
      const res = await getBenefitsCreateV2Fulfillment({
        productId,
        price,
        canSubscribe,
        scenarioCode: SCENARIO_CODE,
        salesChannel: SALES_CHANNEL.updrage,
        foodNotOpen: this.foodNotOpen,
      })
      if (res?.errno === 0) {
        const res1 = await getFintechParams({ renewPrice: 0 })
        if (res1.errno === 0) {
          const resource_id = res1?.data?.resource_id
          // 调用金融的bridge
          const out_trade_id = res?.data?.transId
          const { cityId, clientType, dataType, locationType, osType, osVersion, appId } =
            this.globalParams?.data || {}

          // 客户端要求传string
          doPayV2(
            {
              bizDeviceInfo: JSON.stringify({
                osType: osType + '',
                osVersion: osVersion + '',
                dataType: dataType + '',
                clientType: clientType + '',
                locationType: locationType + '',
                cityId: cityId + '',
              }),
              outTradeId: out_trade_id + '',
              useSodaRandomVerify: true,
              productId: this.getBizId + '',
              appId: appId + '',
              selectedItems: [
                {
                  channelId: val?.channelID + '',
                  extraInfo: { cardIndex: val?.cardIndex + '' },
                },
              ],
              resourceId: resource_id + '',
            },
            async res => {
              this.closeUpgradeDialogAndLoading()
              if (res?.data?.payStatus === PAY_STATUS.SUCCESS) {
                // 刷新当前页面
                this.requestLoading = true
                await this.initCodeData()
                console.log('doPayV2 initCodeData')

                this.requestLoading = false
                this.openPaySuccessDialog()
              } else {
                // 展示失败原因的弹窗
                this.$emit('onUpgradeFail')
              }
            },
          )
        } else {
          this.upgradeBtnLoading = false
          this.createErrorToast(res1.errmsg || '')
          this.initCodeData()
        }
      } else {
        this.upgradeBtnLoading = false
        this.createErrorToast(res.errmsg || '')
        this.initCodeData()
      }
    },
    closeUpgradeDialogAndLoading() {
      this.upgradeBtnLoading = false
      this.$emit('closeUpgradePopup')
    },
    openPaySuccessDialog() {
      this.$emit('onUpgradeSuccess', this.successDialogData)
    },
    // 零元支付的逻辑
    async zeroPayment(channelID, cardIndex) {
      this.requestLoading = true
      const data = await memberBuyFree({
        saleId: this.upgradeLongTerm?.saleID,
        saleChannel: SALES_CHANNEL.updrage,
        isSubscribe: this.upgradeLongTerm?.canSubscribe ? 1 : 0,
        channelID,
        cardIndex,
      })
      this.requestLoading = false
      if (data?.errno === 0) {
        // 重新请求数据
        this.requestLoading = true
        await this.initCodeData()
        this.requestLoading = false
        // 显示支付成功的弹窗
        this.openPaySuccessDialog()
      } else {
        this.createErrorToast(data?.errmsg || '')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

// 规则样式开始------------
.popup-box {
  &.is-tab {
    ::v-deep .half-content {
      padding-bottom: 16px;
    }
  }
}

.change-payment {
  margin-top: 68px;
  margin-bottom: 64px;
}
.popup-wrapper {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.rules-wrapper {
  overflow: auto;
  flex: 1;
  ::v-deep .subscription-text {
    padding: 0 0;
  }
  .subscribe-guide-style {
    padding-top: 12px;
  }
  .title {
    padding-top: 10px;
    padding-bottom: 32px;
    font-family: DiDiSans-Pro-ExtraBold;
    font-size: 40px;
    color: #0b0b0d;
    line-height: 56px;
  }
}
.rule-list {
  .rule-title {
    padding: 40px 0;
    font-family: DiDiSans-Pro-Bold;
    font-size: 36px;
    color: #000000;
    line-height: 36px;
  }
  .rule-desc {
    opacity: 0.6;
    font-family: DiDiSans-Pro-Regular;
    font-size: 28px;
    color: #000000;
    line-height: 34px;
    margin-bottom: 32px;
  }
}
.rule-btn {
  position: relative;
  padding: 0 0 20px 0;
  margin-top: 40px;
  &.footer-container-tab {
    padding-bottom: 0;
  }
  &.footer-android-big {
    padding-bottom: 0; // 安卓-非底导 使用pop容器底部默认paddingbottom
  }
  .rich-btn {
    height: 104px;
    border-radius: 32px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 40px;
    color: #fff;
    font-weight: normal;
    background: #ff5f14;
    &:disabled {
      background: #f5f5f7;
      .price-box {
        color: #d2d2d9;
      }
    }
  }
  .btn-loading {
    background: #ff5f14 !important;
  }
  button {
    height: 120px;
    border-radius: 40px;
  }
  .bubble {
    position: absolute;
    right: 0;
    top: -20px;
  }
  .price {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .price-box {
      position: relative;
      width: fit-content;
      height: fit-content;
      font-family: DiDiSans-Pro-Bold;
      font-size: 40px;
      color: #ffffff;
      letter-spacing: 0;
      // line-height: 56px;
      font-weight: normal;
      &.smallFont {
        font-size: 28px;
        span {
          font-size: 24px;
        }
      }
      span {
        font-family: DiDiSans-Pro-Regular;
        font-size: 28px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 36px;
        font-weight: 400;
        text-decoration: line-through;
      }
    }
  }
}
.btn-tips {
  padding-top: 24px;
  opacity: 0.6;
  font-family: DiDiSans-Pro-Regular;
  font-size: 28px;
  color: #000000;
  text-align: center;
  line-height: 36px;
}
// 规则样式结束------------
::v-deep .wrapper {
  .half-title {
    span {
      margin-left: 0;
    }
  }
}

.plan_wrap {
  clear: both;
  margin-bottom: 20px;
}
.plan_box {
  position: relative;
  width: 100%;
  padding: 40px;
  box-sizing: border-box;
  background: #f5f5f7;
  border-radius: 40px;
  h5 {
    font-family: DiDiSans-Pro-Medium;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    padding-bottom: 8px;
    .tag {
      margin-left: 16px;
      padding: 4px 12px;
      border-radius: 6px 15px 6px 15px;
      background: #f46021;
      font-family: DiDiSans-Pro-Bold;
      font-size: 20px;
      color: #fff;
      letter-spacing: 0;
    }
  }
  .price {
    font-family: DiDiSans-Pro-ExtraBoldTest;
    font-size: 32px;
    color: #0b0b0d;
    line-height: 40px;
    span {
      margin-left: 12px;
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      text-decoration: line-through;
    }
  }
  .favorable {
    margin-top: 20px;
    p {
      font-family: DiDiSans-Pro-Regular;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      margin-bottom: 4px;
      ::v-deep span {
        font-family: DiDiSans-Pro-Bold;
        font-size: 28px;
        color: #ff5f14;
        line-height: 36px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
